import {ref } from 'vue';

const projectList = ref([]);
export const projectLoading = ref(false);
export const projectOptions = ref([]);
export const projectRemote = (query) => {
    if (query) {
        projectLoading.value = true;
        setTimeout(() => {
            projectLoading.value = false
            projectOptions.value = projectList.value.filter((item) => {
                return item.label.toLowerCase().includes(query.toLowerCase())
            })
        }, 200)
    } else {
        projectOptions.value = [];
    }
}


export const cityOptions = ref([]);
export const developerOptions = ref([]);


// function initSwiper() {
//     var swiper = new Swiper(".u-agg-ovinfol-swiper-thumbs", {
//         spaceBetween: 10,
//         slidesPerView: 4,
//         freeMode: true,
//         watchSlidesProgress: true,
//       });
//
//     var swiper2 = new Swiper(".u-agg-ovinfol-swiper", {
//         spaceBetween: 10,
//         navigation: {
//             nextEl: ".u-agg-sw-btn-right",
//             prevEl: ".u-agg-sw-btn-left",
//         },
//         thumbs: {
//             swiper: swiper,
//         },
//     });
// }
//
// export const init = () => {
//     initSwiper();
// }

export const destory = () => {
}